import { Expand, cn } from '@magicdoorinc/ui';
import { Show, splitProps } from 'solid-js';
import type { ComponentProps, JSX } from 'solid-js';

type ExpandableSectionProps = {
  btnClass?: string;
  triggerTitle: JSX.Element;
  children: JSX.Element;
  headerBorder?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  action?: JSX.Element;
  ref?: any;
  noncollapsible?: JSX.Element;
  headerClass?: string;
  triggerTitleAsChild?: boolean;
};

const ExpandableSection = (props: ExpandableSectionProps & ComponentProps<typeof Expand>) => {
  const [expandProps, localProps] = splitProps(props, ['open', 'onOpenChange', 'defaultOpen']);
  return (
    <Expand {...expandProps} class={cn('flex w-full flex-col items-stretch px-4 text-sm text-text-01', localProps.class)}>
      <Expand.Trigger as="div" class="flex w-full justify-between">
        <Show
          when={!localProps.triggerTitleAsChild}
          fallback={
            <div
              class={cn(
                'flex w-full justify-between py-3 text-left text-base font-medium leading-5 md:py-4',
                localProps.headerBorder && expandProps.open && 'mb-4 border-b border-separator',
                localProps.btnClass
              )}>
              {localProps.triggerTitle}
            </div>
          }>
          <button
            type="button"
            class={cn(
              'flex w-full justify-between py-3 text-left text-base font-medium leading-5 md:py-4',
              localProps.headerBorder && expandProps.open && 'mb-4 border-b border-separator',
              localProps.btnClass
            )}>
            {localProps.triggerTitle}
          </button>
        </Show>
        <div
          class={cn('flex items-center gap-1', localProps.headerClass)}
          classList={{
            'border-b border-separator mb-4': localProps.headerBorder && expandProps.open,
          }}>
          <div>{localProps.noncollapsible}</div>
          <div class="flex cursor-pointer items-center gap-3 px-3">
            <div class="rounded hover-allowed:hover:bg-border">{localProps?.action}</div>
            <Expand.Indicator />
          </div>
        </div>
      </Expand.Trigger>
      <Expand.Content>{localProps.children}</Expand.Content>
    </Expand>
  );
};

export default ExpandableSection;
